import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import BottomTabNavigation from '../../components/ui/BottomTabNavigation'
import Button from '../../components/ui/Button'
import Input from '../../components/ui/Input'
import { feedService } from '../../services/feedService'
import { useAuth } from '../../contexts/AuthContext'

const CreatePost = () => {
  const navigate = useNavigate()
  const { user } = useAuth()
  const [content, setContent] = useState('')
  const [mediaUrl, setMediaUrl] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  if (!user) {
    navigate('/login')
    return null
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setError('')
    setLoading(true)
    try {
      await feedService.createPost({ content, mediaUrl: mediaUrl || undefined })
      navigate('/home-feed')
    } catch (submitError) {
      setError(submitError.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-background pb-20">
      <main className="max-w-xl mx-auto px-4 py-10">
        <h1 className="text-2xl font-semibold mb-6">Create Post</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <label className="block">
            <span className="block mb-2">Caption</span>
            <textarea value={content} onChange={(e) => setContent(e.target.value)} className="w-full min-h-32 rounded-lg border border-border bg-card p-3" required />
          </label>
          <Input label="Media URL (optional)" value={mediaUrl} onChange={(e) => setMediaUrl(e.target.value)} />
          {error && <p className="text-sm text-error">{error}</p>}
          <Button type="submit" loading={loading}>Publish</Button>
        </form>
      </main>
      <BottomTabNavigation activeTab="create" />
    </div>
  )
}

export default CreatePost
